module.exports = __webpack_public_path__ + "static/car-pc/img/guide.06c4ea65.png";